import * as Sentry from "@sentry/react-router";

import { HydratedRouter } from "react-router/dom";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

if (import.meta.env.MODE === "production") {
  Sentry.init({
    dsn:
      "https://9018b46f18d35309d3869b71e9e8628a@o4504169423831040.ingest.us.sentry.io/4508365593182208",

    // Add auth context to all errors
    beforeSend(event, hint) {
      const token = sessionStorage.getItem("x_pebble_demo_token");
      const email = sessionStorage.getItem("x_pebble_demo_email");
      const verificationStatus = sessionStorage.getItem(
        "x_pebble_demo_verification"
      );

      if (event.contexts) {
        event.contexts.auth = {
          hasToken: !!token,
          hasEmail: !!email,
          verificationStatus: verificationStatus || "unknown",
        };
      }

      // Filter out network change errors
      const error = hint.originalException;
      if (error && typeof error === "object" && "message" in error) {
        const message = String(error.message);
        if (message.includes("ERR_NETWORK_CHANGED")) {
          return null;
        }
      }

      return event;
    },
  });

  // Catch unhandled promise rejections
  window.addEventListener("unhandledrejection", (event) => {
    Sentry.captureException(event.reason);
  });

  // Catch global errors
  window.addEventListener("error", (event) => {
    Sentry.captureException(event.error);
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
